import { render } from "./Enlarge.vue?vue&type=template&id=ffc410fc&scoped=true"
import script from "./Enlarge.vue?vue&type=script&lang=js"
export * from "./Enlarge.vue?vue&type=script&lang=js"

import "./Enlarge.vue?vue&type=style&index=0&id=ffc410fc&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffc410fc"]])

export default __exports__